import { get, head, partial } from 'lodash';

import {
  getAverageReviewRating,
  getNumberOfProductReviews
} from '../../../shared/utils/product/product';

import { PRODUCT_IMAGE_FORMATS } from '../../../shared/constants/product-images';
import { ARTICLE_STATUSES } from '../../../shared/constants/products';

const getOne = partial(head);
const getOrFind = (g, f, object) =>
  Array.isArray(object) ? f(object) : g(object);
const getUrl = partial(get, partial.placeholder, 'url');
const getThumbnailOrFirst = images =>
  images.length == 1
    ? getUrl(getOne(images))
    : getUrl(
        images.find(
          image =>
            image.format === PRODUCT_IMAGE_FORMATS.THUMBNAIL ||
            image.format === PRODUCT_IMAGE_FORMATS.LIST
        )
      );
const getProductImage = partial(getOrFind, getUrl, getThumbnailOrFirst);

const getAvailability = status => {
  if (status === ARTICLE_STATUSES.ACTIVE) {
    return 'https://schema.org/InStock';
  } else if (status === ARTICLE_STATUSES.BACKORDER) {
    return 'https://schema.org/BackOrder';
  } else if (status === ARTICLE_STATUSES.DISCONTINUED) {
    return 'https://schema.org/Discontinued';
  } else if (status === ARTICLE_STATUSES.PRE_LAUNCH) {
    return 'https://schema.org/PreSale';
  } else {
    return 'https://schema.org/OutOfStock';
  }
};

export function getPlpLD(products, pathname, description, title) {
  if (!products) return null;

  const mainUrl = window.isDT
    ? 'https://www.discounttire.com'
    : 'https://www.americastire.com';

  const itemListElement = products.map(productObj => {
    let product = productObj;

    if (
      process.env.__FF_LOAD_MORE__ === 'true' &&
      typeof productObj?.pageNum === 'number'
    ) {
      product = productObj.product;
    }

    let {
      articleStatus,
      aggregates,
      name = '',
      images,
      url = '',
      price = {},
      priceRange,
      brand = ''
    } = product;

    const offers = priceRange
      ? {
          '@type': 'AggregateOffer',
          highPrice: priceRange?.maxPrice?.value?.toString(),
          lowPrice: priceRange?.minPrice?.value?.toString(),
          offerCount: aggregates?.codes?.length
        }
      : {
          '@type': 'Offer',
          availability: getAvailability(articleStatus),
          price: price?.value?.toString()
        };

    const averageReviewRating = getAverageReviewRating(product);
    let numberOfProductReviews = getNumberOfProductReviews(product);

    const item = {
      '@type': 'Product',
      brand: {
        '@type': 'Brand',
        name: brand
      },
      image: images ? getProductImage(images) : '',
      name: name,
      offers: { priceCurrency: 'USD', ...offers },
      url: `${mainUrl}${url}`
    };

    return numberOfProductReviews === 0 || numberOfProductReviews === undefined
      ? item
      : {
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: averageReviewRating,
            reviewCount: numberOfProductReviews
          },
          ...item
        };
  });

  const mainEntity = {
    '@type': 'ItemList',
    itemListElement: itemListElement,
    numberOfItems: products.length.toString(),
    url: `${mainUrl}${pathname}`
  };

  const plpLD = {
    '@context': 'http://schema.org',
    '@type': 'CollectionPage',
    description: description,
    mainEntity: mainEntity,
    name: title,
    url: `${mainUrl}${pathname}`
  };

  return JSON.stringify(plpLD);
}
